// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2y7sm","footer":"ModalInfo_footer__2aC43"};